import React from 'react';
import { graphql } from 'gatsby';

import * as styles from './BlexiaBanner.module.scss';
import { useTranslation } from 'react-i18next';
import blexiaLogo from '../../src/assets/images/blexia/blexiaLogo.svg';
import { replaceNewLinesWithBr } from '../utils/sanity';
import { FaChevronRight } from 'react-icons/fa';

export const query = graphql`
  fragment BlexiaBanner on SanityBlexiaHomepageBanner {
    backgroundImage {
      asset {
        url
      }
    }
    text
  }
`;

export interface BlexiaBannerProps {
  backgroundImage: {
    asset: {
      url: string;
    };
  };
  text: string;
}

const BlexiaBanner = ({ backgroundImage, text }: BlexiaBannerProps): React.ReactElement => {
  const { t } = useTranslation();

  return (
    <div className={styles.bannerContainer}>
      <div className={styles.content}>
        <div className={styles.textContent}>
          <p>{replaceNewLinesWithBr(text)}</p>
          <a href="/blexia">
            {t('blexia.button_label', 'Know More')} <FaChevronRight fontSize="8px" />
          </a>
        </div>
        <img className={styles.logo} src={blexiaLogo} alt="" />
      </div>
      <div className={styles.overlay}></div>
      <img className={styles.backgroundImage} src={backgroundImage.asset.url} alt="" />
    </div>
  );
};

export default BlexiaBanner;
